"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _appConfig = _interopRequireDefault(require("@nerdwallet/app-config"));

var _getEnvCompatibleAppConfig = _interopRequireDefault(require("../../../env/get-env-compatible-app-config"));

var config = (0, _getEnvCompatibleAppConfig.default)(_appConfig.default);
window.nerdwallet = window.nerdwallet || {};
window.nerdwallet.config = window.nerdwallet.config || {};
window.nerdwallet.config[process.env.CLIENT_ID] = window.nerdwallet.config[process.env.CLIENT_ID] || {};

window.nerdwallet.config[process.env.CLIENT_ID].get = function (key, fallback) {
  return config[key] !== undefined ? config[key] : fallback;
};

window.nerdwallet.config[process.env.CLIENT_ID].all = config;